import { BasePoint } from "slate";

export interface AutosuggestionState {
  text: string;
  point: BasePoint;
}
